import { PureComponent } from 'react'
import styled from 'glamorous'
import map from 'lodash/map'
import noop from 'lodash/noop'

import { $ } from 'utils'
import { Icon, Loader } from 'components'

import MatchDetails from './MatchDetails'


const Container = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  marginLeft: 50,
})

const ListContainer = styled.div({
  width: '770px', // 4 photo width (185) * 3 margin between them (10)
  display: 'flex',
  overflow: 'hidden',
  padding: '0 10px',
  boxSizing: 'content-box',
})

const List = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  paddingBottom: '10px',
  transition: 'margin-left .3s'
}, ({ marginLeft }) => ({
  marginLeft
}))

const ButtonContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'var(--borderColor)',
  width: 35,
  height: 240,
  marginTop: 35,
  '&:hover': {
    backgroundColor: 'var(--lightGrey)',
    cursor: 'pointer',
  }
}, ({ isRight, disabled }) => {
  const style = {}
  if (isRight) {
    style['transform'] = 'rotateZ(180deg)'
  }
  if (disabled) {
    style['opacity'] = 0
    style['&:hover, *:hover'] = {
      cursor: 'default',
      backgroundColor: 'var(--borderColor)'
    }
  }
  return style
})

const ScrollButton = ({ isRight = false, disabled = false, onClick }) =>
  $(ButtonContainer, { isRight, disabled, onClick },
    $(Icon, { type: 'arrowLeft', color: 'var(--grey)' })
  )

export class Matching extends PureComponent {

  state = {
    leftItemIndex: 0,
  }

  render() {
    const { loading, matchType, results, error } = this.props
    if (loading) return $(Loader)
    if (error) return null

    const { leftItemIndex } = this.state
    const disabledLeft = leftItemIndex === 0
    const disabledRight = results.length < 4 || leftItemIndex === results.length - 4

    return (
      $(Container,
        $(ScrollButton, {
          disabled: disabledLeft,
          onClick: disabledLeft ? noop : () => this.setState({ leftItemIndex: leftItemIndex - 1 })
        }),
        $(ListContainer,
          $(List, { marginLeft: `calc(-1 * ${leftItemIndex} * 195px)` },
            map(results, (val, key) =>
              $(MatchDetails, {
                key, listKey: key,
                matchType,
                matchResult: val,
              })),
          )
        ),
        $(ScrollButton, {
          isRight: true,
          disabled: disabledRight,
          onClick: disabledRight ? noop : () => this.setState({ leftItemIndex: leftItemIndex + 1 })
        }),
      )
    )
  }
}

export default Matching



// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/Matching.js